import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import { aggregationTypes } from '../../constants/event';

const { Option } = Select;

const StyledAggregateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const StyledSelect = styled(Select)`
  width: 250px;
`;

export const getAggregationTypeOptions = (splitColumn) => [
  <Option key={aggregationTypes.COUNT} value={aggregationTypes.COUNT}>
    Count
  </Option>,
  <Option key={aggregationTypes.UNIQ} value={aggregationTypes.UNIQ}>
    Users
  </Option>,
  <Option key={aggregationTypes.SUM} value={aggregationTypes.SUM}>
    Total
  </Option>,
  <Option key={aggregationTypes.AVG_COUNT} value={aggregationTypes.AVG_COUNT}>
    Count / Users
  </Option>,
  <Option key={aggregationTypes.AVG_TOTAL} value={aggregationTypes.AVG_TOTAL}>
    Total / Users
  </Option>,
  splitColumn && (
    <Option key={aggregationTypes.AVG_COUNT_SPLIT} value={aggregationTypes.AVG_COUNT_SPLIT}>
      Count / Users(Split)
    </Option>
  ),
  splitColumn && (
    <Option key={aggregationTypes.AVG_TOTAL_SPLIT} value={aggregationTypes.AVG_TOTAL_SPLIT}>
      Total / Users(Split)
    </Option>
  ),
];

const AggregateContainer = ({ aggregationType, onChangeAggregationType, splitColumn }) => {
  return (
    <StyledAggregateContainer>
      Aggregate by:
      <StyledSelect
        onSelect={(aggregationTypeParam) => onChangeAggregationType(aggregationTypeParam)}
        value={aggregationType}
        dropdownMatchSelectWidth
        dropdownStyle={{ width: 'auto' }}
        className="ant-select-border-bottom"
        getPopupContainer={(triggerNode) => triggerNode}
        virtual={false}
      >
        {getAggregationTypeOptions(splitColumn)}
      </StyledSelect>
    </StyledAggregateContainer>
  );
};

export default AggregateContainer;
